import { Tabs, TabsTrigger, TabsContent, TabsList } from "@/components/ui/tabs";
import SummaryComponent from "./SummaryComponent";
import DocumentsComponent from "./DocumentsComponent";
import { UseFormReturn } from "react-hook-form";
import { Document } from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { JSX } from "react";

interface SidebarComponentProps {
  form: UseFormReturn<any>;
  documents: Document[];
  children?: React.ReactNode;
}

function SidebarComponent({ form, documents, children }: SidebarComponentProps): JSX.Element {
  const { t } = useTranslation(["components"]);

  return (
    <div className="p-4">
      <Tabs defaultValue="summary">
        <div className="flex justify-between items-center">
          <TabsList>
            <TabsTrigger value="summary">{t("createtendersidebar.summary.trigger")}</TabsTrigger>
            <TabsTrigger value="documents">{t("createtendersidebar.documents.trigger")}</TabsTrigger>
          </TabsList>
          {children}
        </div>
        <TabsContent value="summary">
          <SummaryComponent form={form} />
        </TabsContent>
        <TabsContent value="documents">
          <DocumentsComponent documents={documents} />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default SidebarComponent;
